import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67d78574"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chain-solver__task" }
const _hoisted_2 = {
  key: 0,
  class: "chain-solver__steps-container"
}
const _hoisted_3 = {
  key: 1,
  class: "chain-solver__steps-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_timer_box = _resolveComponent("timer-box")!
  const _component_game_step_indicator = _resolveComponent("game-step-indicator")!
  const _component_game_wrapper = _resolveComponent("game-wrapper")!

  return (_openBlock(), _createBlock(_component_game_wrapper, {
    title: "Chain Solver",
    name: "ChainSolver",
    "is-game-over": _ctx.isGameOver,
    counter: _ctx.restartCounter,
    "score-elements": _ctx.scoreElements,
    "action-buttons": _ctx.currentActionButtons,
    onPrecountdownOver: _ctx.startGameTimer,
    onRestart: _ctx.restart,
    onNext: _ctx.nextStep,
    onCommitSolution: _ctx.commitSolution,
    onNegate: _ctx.negateSolution,
    onNumber: _ctx.addSolutionNumber,
    onNumberDelete: _ctx.deleteFromSolution,
    onConfirm: _ctx.confirmSolution
  }, {
    top: _withCtx(() => [
      _createVNode(_component_timer_box, {
        class: "chain-solver__timer",
        timer: _ctx.gameTimer,
        threshold: _ctx.gameTimeThreshold
      }, null, 8, ["timer", "threshold"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.isFinalStep ? _ctx.finalStepDisplay : _ctx.task.taskSteps[_ctx.stepIndex]), 1)
    ]),
    bottom: _withCtx(() => [
      (!_ctx.isGameOver)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameSteps, (step) => {
              return (_openBlock(), _createBlock(_component_game_step_indicator, {
                key: step.name,
                step: step
              }, null, 8, ["step"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isGameOver)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gamePhases, (step) => {
              return (_openBlock(), _createBlock(_component_game_step_indicator, {
                key: step.name,
                step: step
              }, null, 8, ["step"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-game-over", "counter", "score-elements", "action-buttons", "onPrecountdownOver", "onRestart", "onNext", "onCommitSolution", "onNegate", "onNumber", "onNumberDelete", "onConfirm"]))
}